import type { Resource } from '../../';
export const country_countries_CZ: Resource = {"default":"Czech Republic"};
